import React from 'react';
import './app.css';
import { AppRoute } from './routes/appRoute';
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';

function App() {
  return (
    <div className='container-fluid'>
      <ReactNotifications />
      <AppRoute></AppRoute>
    </div>
  );
}

export default App;
